module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Media-library3-ef24d67aebb667fe5765a44ba1fffb59.svg";